// extracted by mini-css-extract-plugin
export default {"wrapper":"JO4J4","prices":"dwHjT","with-discount":"Tre40","price-value":"cuqun"};